import type { AdminFilterOption } from './organizationFilters';
import type { WhatsappProvider, WhatsappStatusBucket } from './types';

export const WHATSAPP_STATUS_BUCKET_FILTERS: AdminFilterOption[] = [
  { value: 'connected', label: 'Conectado' },
  { value: 'disconnected', label: 'Desconectado' },
  { value: 'pending', label: 'QR / Conectando' },
];

export const WHATSAPP_PROVIDER_FILTERS: AdminFilterOption[] = [
  { value: 'uazapi', label: 'UAZAPI' },
  { value: 'unknown', label: 'Desconhecido' },
];

export type AdminWhatsappFilters = {
  statusBucket: string;
  provider: string;
};

export const EMPTY_WHATSAPP_FILTERS: AdminWhatsappFilters = {
  statusBucket: '',
  provider: '',
};

export function whatsappStatusLabel(bucket: WhatsappStatusBucket): string {
  return WHATSAPP_STATUS_BUCKET_FILTERS.find((o) => o.value === bucket)?.label ?? bucket;
}

export function whatsappProviderLabel(provider: WhatsappProvider): string {
  return WHATSAPP_PROVIDER_FILTERS.find((o) => o.value === provider)?.label ?? provider;
}
